import * as React from 'react';

import 'css!./__styles__/SettingsHelp';

const SettingsHelp = ({ children }: React.PropsWithChildren<{}>) => {
  return <div className="rc-SettingsHelp">{children}</div>;
};

export default SettingsHelp;
